export default function site(state = {
  content: {}
}, action) {
  switch (action.type) {
    case "CONTENT_FETCHED":
      return Object.assign({}, state, {
        content: action.payload.content
      })
    default:
      return state
  }
}
